import React from 'react'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined'
import { HashLink } from 'react-router-hash-link'
import Link from '@material-ui/core/Link'
import makeStyles from '@material-ui/core/styles/makeStyles'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  flex: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  mobileLayout: {
    marginBottom: '2rem',
    gap: '6px',
    flexDirection: 'column',
  },
  icon: {
    marginRight: '6px',
    width: '18px',
    height: '18px',
  },
}))

const HeaderScheduleDivider = () => (
  <Divider
    component="span"
    orientation="vertical"
    flexItem
    style={{ margin: '0 16px 0 16px' }}
  />
)

const HeaderScheduleText = ({ eventCount, eventDates }) => {
  const classes = useStyles()
  if (eventCount < 1) return <span>Event Schedule TBD</span>
  if (eventCount === 1) {
    return (
      <>
        <span>{eventDates.dates}</span>
        <HeaderScheduleDivider />
        <span>{eventDates.time}</span>
      </>
    )
  }
  return (
    <>
      <span>{eventDates.dates}</span>
      <HeaderScheduleDivider />
      <span>{eventCount} Events</span>
      <HeaderScheduleDivider />
      <span>
        <CalendarTodayOutlinedIcon className={classes.icon} />
        <Link
          component={HashLink}
          smooth
          to="#schedule"
          style={{ color: 'inherit' }}
        >
          View Schedule
        </Link>
      </span>
    </>
  )
}

const HeaderSchedule = ({ isMobile, eventCount, eventDates }) => {
  const classes = useStyles()
  return (
    <Typography
      variant="body1"
      className={clsx(classes.flex, isMobile && classes.mobileLayout)}
      gutterBottom
    >
      <HeaderScheduleText eventCount={eventCount} eventDates={eventDates} />
    </Typography>
  )
}

export default HeaderSchedule
